<template>
  <div style="background-color: #f4f4f4">
    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          md="10"
          offset-md="1"
          lg="10"
          offset-lg="1"
          xl="8"
          offset-xl="2"
          class="mb-10"
        >
          <v-row>
            <v-col>
              <v-sheet>
                <v-toolbar flat>
                  <v-toolbar-title
                    class="title text-uppercase"
                    :style="{
                      margin: $vuetify.breakpoint.lgAndUp ? '' : 'auto',
                    }"
                    >My Identity</v-toolbar-title
                  >
                </v-toolbar>
              </v-sheet>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <div class="customHeader">
                <h2>ผลสรุป</h2>
              </div>
              <div class="customContent" align="center">
                <div id="chart"></div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="customContent" align="center" style="width: 100%">
                <div
                  style="color: #224f84; font-size: 20px; font-weight: bold"
                  class="pb-5"
                >
                  ผลการประเมิน
                </div>
                รายละเอียด รายละเอียด รายละเอียด รายละเอียด รายละเอียด
                รายละเอียด รายละเอียด รายละเอียด รายละเอียด รายละเอียด
                รายละเอียด รายละเอียด รายละเอียด รายละเอียด
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div class="customHeader">
                <h2>คอร์สแนะนำ</h2>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <course-renderer
                :courses="courses"
                :items-per-page="itemsPerPage"
                :show-loader="courseLoader"
                :page.sync="currentPage"
              ></course-renderer>
            </v-col>
          </v-row>

          <div class="text-center pt-5">
            <v-pagination
              v-model="page"
              :length="6"
              color="rgb(66, 154, 216)"
            ></v-pagination>
          </div> -->

          <v-btn
            color="#009bde"
            dark
            style="width: 100%; height: 70px"
            class="mt-5 mb-5"
            @click="openAssessment"
          >
            ทำแบบสำรวจใหม่
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import CourseRenderer from "@/components/CourseRenderer.vue";
import Vue from "vue";
import { environment } from "../store/environment";
var CryptoJS = require("crypto-js");

export default {
  data: function () {
    return {
      rating: 4.5,
      page: 1,
      resp: {
        status: true,
        result: {
          elements: [
            {
              template: "course_vertical_gridview",
              title: "Recommended Courses",
              body: [
                {
                  categories: [
                    { _id: "5f3b7cdda48c4d52a612d6e9", title: "การท่องเที่ยว" },
                  ],
                  admins: [],
                  rating: 0,
                  haveDashboard: false,
                  useBoard: false,
                  haveInbox: false,
                  countMylib: 1016,
                  countSection: 1,
                  countRoomSection: 1,
                  countBundle: 1,
                  active: true,
                  action: "show_course_detail",
                  localizations: [
                    { title: "แพ 500 ไร่", lang: "th" },
                    { title: "แพ 500 ไร่", lang: "en" },
                  ],
                  _id: "5f5b242ea0e9df6a8ca62d62",
                  title: "แพ 500 ไร่",
                  image:
                    "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
                  prices: [],
                  owner_by_students: [
                    {
                      initCreate: true,
                      _id: {
                        image:
                          "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                        description: null,
                        email: "sommai@gmail.com",
                        localizations: null,
                        _id: "5f43299a0db6cc79189cd6f6",
                        firstName: "sommai",
                        lastName: "medee",
                        displayName: "sommai medee",
                        gender: "male",
                      },
                    },
                  ],
                  owner_by_tutors: [],
                  owner_by_staffs: [],
                  created_at: 1599808558202,
                },
                {
                  categories: [
                    { _id: "5f3b7cdda48c4d52a612d6e9", title: "การท่องเที่ยว" },
                  ],
                  admins: [],
                  rating: 0,
                  haveDashboard: false,
                  useBoard: false,
                  haveInbox: false,
                  countMylib: 3,
                  countSection: 0,
                  countRoomSection: 1,
                  countBundle: 2,
                  active: true,
                  action: "show_course_detail",
                  localizations: [],
                  _id: "5f3b9a20a48c4d52a612d7c8",
                  title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
                  image:
                    "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
                  prices: [],
                  owner_by_students: [
                    {
                      initCreate: true,
                      _id: {
                        image:
                          "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                        description: null,
                        email: "support@nerdof.com",
                        localizations: null,
                        _id: "5f3b5147a48c4d52a612d627",
                        firstName: "Admin",
                        lastName: "Deknerd Staging",
                        displayName: "Admin Deknerd Staging",
                        gender: "male",
                      },
                    },
                  ],
                  owner_by_tutors: [],
                  owner_by_staffs: [],
                  created_at: 1597741600506,
                },
              ],
              headerButton: null,
              footerButton: {
                action: "show_course_list_search",
                title: "See more",
                color: "#2E3C91",
                method: "GET",
                queries: [
                  { param: "search", value: "null" },
                  { param: "skill", value: "null" },
                  { param: "category", value: "null" },
                  { param: "owner", value: "null" },
                  { param: "grade", value: "null" },
                  { param: "type", value: "course" },
                  { param: "sort", value: "created_at" },
                  { param: "sortby", value: "-1" },
                  { param: "page", value: "1" },
                  { param: "limit", value: "10" },
                ],
              },
            },
          ],
        },
      },
      courses: null,
      itemsPerPage: 10,
      courseLoader: false,
      currentPage: 1,
    };
  },
  components: {
    CourseRenderer,
  },
  methods: {
    init() {
      var options = {
        series: [
          {
            name: "Series 1",
            data: [20, 100, 40, 30, 50, 80, 33],
          },
        ],
        chart: {
          toolbar: {
            show: false,
          },
          height: 320,
          type: "radar",
        },
        dataLabels: {
          enabled: true,
        },
        plotOptions: {
          radar: {
            size: 130,
            polygons: {
              strokeColors: "#e9e9e9",
              fill: {
                colors: ["#f8f8f8", "#fff"],
              },
            },
          },
        },
        //title: {
        //text: 'Radar with Polygon Fill'
        //},
        colors: ["#FF4560"],
        markers: {
          size: 4,
          colors: ["#fff"],
          strokeColor: "#FF4560",
          strokeWidth: 2,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
        xaxis: {
          categories: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
        yaxis: {
          tickAmount: 7,
          labels: {
            formatter: function (val, i) {
              if (i % 2 === 0) {
                return val;
              } else {
                return "";
              }
            },
          },
        },
      };

      var chart = new ApexCharts(document.querySelector("#chart"), options);
      chart.render();

      //Course

      this.courses = [
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 1016,
          countSection: 1,
          countRoomSection: 1,
          countBundle: 1,
          active: true,
          action: "show_course_detail",
          localizations: [
            {
              title: "แพ 500 ไร่",
              lang: "th",
            },
            {
              title: "แพ 500 ไร่",
              lang: "en",
            },
          ],
          _id: "5f5b242ea0e9df6a8ca62d62",
          title: "แพ 500 ไร่",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/0a2cfb64-151a-4388-a714-94c3aa60e64e.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/c808bb42-2fb9-4af3-8a64-393fe1aa93d5.png",
                description: null,
                email: "sommai@gmail.com",
                localizations: null,
                _id: "5f43299a0db6cc79189cd6f6",
                firstName: "sommai",
                lastName: "medee",
                displayName: "sommai medee",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1599808558202,
        },
        {
          categories: [
            {
              _id: "5f3b7cdda48c4d52a612d6e9",
              title: "การท่องเที่ยว",
            },
          ],
          admins: [],
          rating: 0,
          haveDashboard: false,
          useBoard: false,
          haveInbox: false,
          countMylib: 3,
          countSection: 0,
          countRoomSection: 1,
          countBundle: 2,
          active: true,
          action: "show_course_detail",
          localizations: [],
          _id: "5f3b9a20a48c4d52a612d7c8",
          title: "การเดินทาง ท่องเที่ยว ฟื้นฟูใจ",
          image:
            "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/course/55eda31d-c01c-4b81-bb97-67c621bddcb3.jpg",
          prices: [],
          owner_by_students: [
            {
              initCreate: true,
              _id: {
                image:
                  "https://s3.ap-southeast-1.amazonaws.com/s3-amr.deknerd.com/image/user/0a5eaef5-fcef-488e-8ac0-80cdbba539c7.png",
                description: null,
                email: "support@nerdof.com",
                localizations: null,
                _id: "5f3b5147a48c4d52a612d627",
                firstName: "Admin",
                lastName: "Deknerd Staging",
                displayName: "Admin Deknerd Staging",
                gender: "male",
              },
            },
          ],
          owner_by_tutors: [],
          owner_by_staffs: [],
          created_at: 1597741600506,
        },
      ];
    },
    openAssessment() {
      console.log("Yes");
      //#region generate data
      let data = {
        numStamp: `${Vue.prototype.$userInfo._id}${Date.now()}`,
        token: this.$cookies.get("user_token"),
        course: "6037a3cd681ca725e591524e",
      };
      let url = environment.assessmentDomain;
      //#endregion

      //#region encrypt data
      let jsonData = JSON.stringify(data);
      let secret = "kJYSb2aTHqa3JBGV";
      let encrypted = CryptoJS.AES.encrypt(jsonData, secret);
      let sessionData = encrypted.toString();
      let sessionData_encodeURI = encodeURIComponent(sessionData);
      //#endregion

      //#region openTab
      var a = window.document.createElement("a");
      a.target = "_blank";
      a.href = `${url}?session=${sessionData_encodeURI}`;

      // Dispatch fake click
      var e = window.document.createEvent("MouseEvents");
      e.initMouseEvent(
        "click",
        true,
        true,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      a.dispatchEvent(e);
      //#endregion
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.customHeader {
  background-color: #e2e8ee;
  padding: 10px 10px 10px 10px;
  color: #506883;
}
.customContent {
  background-color: #ffffff;
  padding: 10px 10px 10px 10px;
  font-size: 15px;
  color: #828282;
}

.customCard {
  background-color: #ffffff;
  padding: 10px 10px 10px 10px;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: #dcdcdc;
}

.centerContainer {
  position: relative;
}

.center-vertically {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.center-vertical-horizonrally {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.course-catagory {
  color: #224f84;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  padding-bottom: 5px;
}

.course-title {
  color: #000000;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
}
</style>